import { FormControl, Select } from "@mui/material";
import React, { useMemo, useState } from "react";
import axios from "axios";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import SaveButton from "../../../components/CustomInput/SaveButton";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import { convertArrayToSelectOptions } from "../../../templateHelpers";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { customExports } from "../../../variables/app";
import { useFormContext } from "react-hook-form";
import { format } from "date-fns";
import { DateTimePicker } from "@mui/x-date-pickers";

function CustomExports() {
  const { vestigingId, menukaartVestigingId } = useFormContext();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [type, setType] = useState(null);
  console.log(startDate);
  const handleDateChange = (type, date) => {
    if (type === "startDate") {
      setStartDate(date);
    } else if (type === "endDate") {
      setEndDate(date);
    }
  };

  const handleDropdown = (type, event) => {
    if (type === "type") {
      setType(event.target.value);
    }
  };

  const exportFile = () => {
    let url =
      "/core/vestigingen/" +
      vestigingId +
      "/customexports?type=" +
      type +
      "&startdatum=" +
      format(startDate, "yyyy-MM-dd") +
      "&einddatum=" +
      format(endDate, "yyyy-MM-dd");

    axios({
      url: url, //your url
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", type + ".xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };

  const customExportsOptions = useMemo(() => convertArrayToSelectOptions(customExports), []);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <h3>
            <TranslationWrapper tDefault={"Custom Field Exports"} tKey={"vestigingen.form.exports.headers.exports"} />
          </h3>
          <GridContainer>
            <GridItem md={2} xs={12}>
              <DateTimePicker
                closeOnSelect
                label={<TranslationWrapper tDefault={"Van"} tKey={"global.van"} />}
                onChange={(date) => handleDateChange("startDate", date)}
                value={startDate}
              />
            </GridItem>
            <GridItem md={2} xs={12}>
              <DateTimePicker
                closeOnSelect
                label={<TranslationWrapper tDefault={"Tot"} tKey={"global.tot"} />}
                onChange={(date) => handleDateChange("endDate", date)}
                value={endDate}
              />
            </GridItem>
            <GridItem sm={4} xs={12}>
              <br />
              <FormControl fullWidth>
                <Select
                  onChange={(e) => {
                    handleDropdown("type", e);
                  }}
                  value={type}
                >
                  {customExportsOptions}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem sm={4} xs={12}>
              <br />
              <SaveButton buttonText={"export"} hasError={false} onClick={exportFile} saving={false} />
            </GridItem>
          </GridContainer>
          <a href={"/manager/core/vestigingen/" + menukaartVestigingId + "/exportcustomfields_xls"}>
            <TranslationWrapper
              tDefault={"Velden export afgelopen 14 dagen"}
              tKey={"vestigingen.form.algemeen.headers.DownloadExportCustomFields"}
            />
          </a>
        </CardBody>
      </Card>
    </div>
  );
}

export default CustomExports;
